import React, { useEffect, useState } from "react";
import urlParser from "js-video-url-parser/dist/jsVideoUrlParser.js?v=1.2";
import { useAuth } from "../../../../Context/store/context";
import { _put } from "../../../../../apiClient";
import { _showToast } from "../../../../../toastHelper";

export default function ChangeLiveUrl(props) {
    const [liveUrl, setLiveUrl] = useState("");
    const [errors, setErrors] = useState({});
    const { showLoader, hideLoader } = useAuth();

    useEffect(() => {
        setLiveUrl(props.url);
    }, [])

    const validate = () => {
        const errors = {};
        if (!liveUrl || (liveUrl && liveUrl.trim() == "")) {
            errors.liveUrl = "Live link is required";
        }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    }

    const saveHandler = async () => {
        if (validate()) {
            let parsedData = urlParser.parse(liveUrl);
            if (parsedData && parsedData?.id && parsedData.id != "") {
                await callUpdateApi();
            }
            else {
                const errors = {};
                errors.liveUrl = "Invalid youtube live link";
                setErrors(errors);
            }
        }
    }

    const callUpdateApi = async () => {
        showLoader();
        await  _put("/events/updateliveurl",
            {
                "id": props.invitationId,
                "liveUrl": liveUrl
            }
        ).then(() => {
            hideLoader();
            _showToast("Live url updated successfully", "success");
            props.onClose();
        }).catch((error) => {
            hideLoader();
            _showToast(error, "error");
        });
    }

    return (
        <div className="modal fade show" aria-modal="true" role="dialog" style={{ display: "block" }}>
            <div className="modal-dialog modal-md modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Change Live Link</h5>
                        <button type="button" className="btn-close" onClick={props.onClose}></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <label className="form-label required">Youtube Live Link</label>
                            <input id="video-link" type="text" className={`form-control ${errors.liveUrl ? "is-invalid" : ""}`}
                                value={liveUrl} onChange={(e) => setLiveUrl(e.target.value)} />
                            <small>Add any public Youtube Live link</small>
                            {errors.liveUrl && (
                                <div className="invalid-feedback">
                                    {errors.liveUrl}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary" onClick={saveHandler}>Save</button>
                        <button className="btn btn-secondary" onClick={props.onClose}>Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
